<template>
  <div class="faq-library-basicpage">
    <div class="third-rea banji">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="search">查询</el-button>
          <el-button class="btn-two" type="default" @click="reset">重置</el-button>
          <span class="btn-shu"></span>
          <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
        </div>
      </div>
      <div class="third-search">
        <el-form :inline="true" :model="searchForm" label-width="76px" ref="searchForm">
          <div class="search-row">
            <div class="row-item">
              <el-form-item label="问题名称">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="searchForm.questionName"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="答案类型">
                <el-select class="item-input" v-model="searchForm.faqType" placeholder="请选择">
                  <el-option label="全部" value></el-option>
                  <el-option label="文本" :value="1"></el-option>
                  <el-option label="链接" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="答案">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="searchForm.faq"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label-width="90px" label="是否为常见问题">
                <el-select class="item-input" v-model="searchForm.display" placeholder="请选择">
                  <el-option label="全部" value></el-option>
                  <el-option label="展示" :value="1"></el-option>
                  <el-option label="不展示" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one">
      <div class="one-left">
        <div class="left-tab">
          <div class="tab-one custom-tree_tab">
            <span>分类列表</span>
          </div>
        </div>
        <div class="left-tree">
          <div class="tree-nodata" v-if="treeData[0].children.length === 0">暂无分类，请点击右上角【+】创建</div>
          <el-tree
            class="tableListPage"
            ref="treeList"
            :data="treeData"
            node-key="questionType"
            default-expand-all
            :expand-on-click-node="false"
            @node-click="handleNodeClick"

            highlight-current
            :props="defaultProps" >
            <span class="custom-tree-node-list" @mouseover="treeNodeHover(node, data)" @mouseleave="treeNodeLeave(node, data)" slot-scope="{ node, data }" >
              <span class="custom-tree-node">
                <template v-if="node.level === 1">
									<!-- <i class="iconfont_12 iconfolder"></i>
									<span class="tree-node-title" style="padding-left: 8px; padding-right: 8px;" >{{node.level === 1 ? node.label : data.typeName}}</span> -->
									<span class="tree-img-box">
                    <i class="iconfont_12 iconfolder"></i>
                  </span>
                  <span style="padding-left: 6px;font-weight: bold">{{node.label}}</span>
                  <span class="add-node" @click="addData(node,data)">
                    <i class="el-icon-plus"></i>
                  </span>
                  <span class="add-node" @click="refreshTree">
                    <i class="el-icon-refresh"></i>
                  </span>
                </template>
								<template v-else>
									<span class="tree-img-box">
										<i class="iconfont_12 icon-shouye-biaoqianfenlei"></i>
									</span>
									<span style="padding-left: 6px;">{{node.label}}</span>
									<span class="edit-node" @click="editDataBase(data)">
										<i class="el-icon-edit-outline"></i>
									</span>
									<span class="delete-node" @click="deleteDataBase(data)">
										<i class="el-icon-delete"></i>
									</span>
								</template>

                <!-- <div class="tree-node-icon" style="display: inline-block; padding-right: 8px;">
                  <span @click="addData(node, data)" style="padding-right: 8px;" v-if="node.level === 1" >
                    <i class="el-icon-plus"></i>
                  </span>
                  <span @click="refreshTree" v-if="node.level === 1">
                    <i class="el-icon-refresh"></i>
                  </span>
                  <span @click.stop="editDataBase(data)" style="padding-right: 8px;" v-if="node.level !== 1" class="node-edit">
                    <i class="el-icon-edit-outline"></i>
                  </span>
                  <span @click.stop="deleteDataBase(data)" v-if="node.level !== 1" class="node-delete" >
                    <i class="el-icon-delete"></i>
                  </span>
                </div> -->

              </span>
            </span>
          </el-tree>
        </div>
      </div>
      <div class="one-right">
        <div class="third-do-btn">
          <div class="do-btn-left">
            <el-button
              class="do-btn-four"
              type="default"
              icon="el-icon-download"
              @click="importData"
            >导入数据</el-button>
            <el-button
              class="do-btn-four"
              type="default"
              icon="el-icon-upload2"
              @click="pullOut"
            >导出数据</el-button>
            <el-button
              class="do-btn-two"
              type="default"
              icon="el-icon-plus"
              @click="addItem(null)"
            >新增</el-button>
            <el-button
              class="do-btn-two"
              type="default"
              icon="el-icon-delete"
              @click="deleteItem(null)"
            >删除</el-button>
          </div>
          <div class="do-btn-right">
            <div class="do-btn-check">
              <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
              <span class="btn-check-span">显示高级功能</span>
            </div>
            <div class="do-btn-hign-list" v-if="checked">
              <!-- 展示字段 -->
              <sort-data
                :tableRow="tableRow"
                @showList="getTableList"
                sessionOriginalName="odSortOrignalData_robotFAQLibrary"
                sessionResultName="SortData_robotFAQLibrary"
              ></sort-data>
              <!-- 数据顺序 -->
              <display-field
                :selectList="tableRow"
                sessionOriginalName="odDisplayFiedOrignal_robotFAQLibrary"
                @setDataOrder="getDataOrder"
                sessionResultName="DisplayFied_robotFAQLibrary"
              ></display-field>
            </div>
          </div>
        </div>
        <el-table
          ref="faqTableData"
          class="third-tableThree"
          :data="tableData"
          empty-text="暂无数据"
          row-key="questionId"
          @selection-change="handleSelectChange"
          border
          stripe
          v-loading="loading"
        >
          <el-table-column type="selection" reserve-selection width="32px"></el-table-column>
          <template v-for="(item, index) in tableDataShow">
            <el-table-column
              v-if="item.needKeyValue"
              min-width="80px"
              :prop="item.key"
              :label="item.column"
              :key="index"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="item.key === 'answerType'">
                  <span v-if="scope.row[item.key] === 1">文本</span>
                  <span v-if="scope.row[item.key] === 2">链接</span>
                </span>
                <span v-if="item.key === 'isShow'">
                  <span v-if="scope.row[item.key] === 1">是</span>
                  <span v-if="scope.row[item.key] === 0">否</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              min-width="100px"
              :prop="item.key"
              :label="item.column"
              :key="index"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </template>
          <el-table-column prop="address" min-width="80px" label="操作">
            <template slot-scope="scope">
              <el-button @click="addItem(scope.row)" type="text" size="small">详情</el-button>
              <span class="tableThree-height-shu">
                <span class="shu-item"></span>
              </span>
              <el-button @click="deleteItem(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="third-page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :isError="isError"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    ></notice-modal>
    <hign-modal
      :hignModalVisible="hignModal"
      @searchModal="toHignSearch"
      @cancelModal="closeModal"
      :hignOneList="tableRow"
    ></hign-modal>
     <push-Into
      :importModal="importModal"
      @closeNewTask="closeImport"
      actionURL="/api/blade-platform/aiquestion/excel/upload"
      downloadURL="/api/blade-platform/aiquestion/downloadExcel"
      relationURL="/api/blade-platform/aiquestion/excel/match"
      DaoruURL="/api/blade-platform/aiquestion/excel/import"
      IngURL="/api/blade-platform/aiquestion/excel/import/conf"
      upFailURL="/api/blade-platform/aiquestion/downloadErrorExcel"
    ></push-Into>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { setStore, getStore } from "@/utils/store";

export default {
  name: "robotFAQLibrary",

  data() {
    return {
      importModal: false,
      outputModal: false,
      loading: false,
      defaultProps: {
        children: "children",
        label: "typeName"
      },
      bmList: [], // 编码列表
      rulesImport: {
        sjklx: [{ required: true, message: "请选择", trigger: "change" }],
        ljmc: [{ required: true, message: "请输入", trigger: "blur" }],
        zjip: [{ required: true, message: "请输入", trigger: "blur" }],
        dkh: [{ required: true, message: "请输入", trigger: "blur" }],
        sjkm: [{ required: true, message: "请输入", trigger: "blur" }],
        yhm: [{ required: true, message: "请输入", trigger: "blur" }],
        pwd: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      addModal: false, //
      isError: true, // 是否是错误提示
      noticeSpec: "分类删除后不可恢复，", // 标红提示
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定删除吗？", // 提示信息
      noticeModal: false, // 提示弹窗
      delectID: "", //删除一条数据的ID
      treeData: [
        {
          typeName: "所有分类",
          children: [],
          show: false
        }
      ], // 树节点数据
      pageSize: 40,
      pageNum: 1,
      total: 0,
      tableData: [],
      hignModal: false, // 高级搜索
      searchForm: {
        questionName: "",
        faqType: "",
        faq: "",
        display: ""
      },
      checked: true,
      checkClassList: [],
      checkID: "", //表格选中的ID
      hignSearchRes: "", // 高级检索条件
      orderConfig: "", // 字段展示和顺序需要的参数
      tableDataShow: [],
      countNum: 1, // 默认为1，以提醒第一个必填
      tableRow: [
        {
          column: "问题名称",
          key: "questionName",
          needKeyValue: false,
          caseKey: "question_name"
        },
        {
          column: "问题分类",
          key: "questionTypeName",
          needKeyValue: false,
          caseKey: "question_type_name",
        },
        {
          column: "答案类型",
          key: "answerType",
          needKeyValue: true,
          caseKey: "answer_type",
          isCustomList: [
            {
              label: '文本',
              value: '1'
            },
            {
              label: '链接',
              value: '2'
            }
          ]
        },

        {
          column: "答案",
          key: "answer",
          needKeyValue: false,
          caseKey: "answer"
        },
        {
          column: "是否为常见问题",
          key: "isShow",
          needKeyValue: true,
          caseKey: "is_show",
          isCustomList: [
            {
              label: '是',
              value: 1
            },
            {
              label: '否',
              value: 0
            }
          ]
        },
        {
          column: "展示顺序",
          key: "sort",
          needKeyValue: false,
          caseKey: "sort"
        },
        {
          column: "被搜索次数（次）",
          key: "count",
          needKeyValue: false,
          caseKey: "count"
        },
        {
          column: "更新时间",
          key: "updateTime",
          needKeyValue: false,
          caseKey: "update_time"
        }
      ],
      selectData: "", // 选中分类
      apiServerDataBaseId: "", // 分类id
      deleteType: 1 // 删除类型，1分类，2单项列表删除，3批量删除, 4关闭
    };
  },
  created() {
    console.log("0000000000");
    sessionStorage.setItem('apiServerDataBaseId', '')
    const dispField = this.getSessonValue("robotFAQLibrary_DisplayFied");
    const tableRow = this.getSessonValue("robotFAQLibrary_SortData");
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      this.tableDataShow = tableRow;
    } else {
      this.tableDataShow = this.tableRow;
    }
    this.getFAQTypeList();
  },
  computed: {
    ...mapState({
      componentsName: state => state.robotsManage.robotsManageComponentName
    })
  },
  methods: {
    ...mapMutations({
      changeComponentName: "SET_robotsManage_faqLibrary_ComponentName"
    }),
    ...mapActions([
      "questionTypeList",
      "removeFAQ",
      "removeFAQType",
      "aiquestionList"
    ]),
    pullOut() {
        this.$downLoadFile('/api/blade-platform/aiquestion/exportExcel', this.searchForm, '问题库' + ".xls");
    },
    // 关闭导出
    closeOutPut() {
      this.outputModal = false;
    },
    // 导出数据
    outputData() {
      this.outputModal = true;
    },
    // 导入数据
    importData() {
      this.importModal = true;
    },
    // 取消导入
    closeImport() {
      this.importModal = false;
    },
    // 树节点渲染
    renderContent(h, { node, data }) {
      if (node.level == 1) {
        return (
          <span class="custom-tree-node">
            <i class="iconfont_12 iconfolder"></i>
            <span style="padding-left: 8px; font-weight: bold;">
              {node.label}
            </span>
          </span>
        );
      } else {
        if (data.children.length !== 0) {
          return (
            <span class="custom-tree-node">
              <i class="iconfont_12 iconmulu"></i>
              <span style="padding-left: 8px;">
                {node.label}
              </span>
            </span>
          );
        } else {
          return (
            <span class="custom-tree-node">
              <i class="iconfont_12 iconxiangmu"></i>
              <span style="padding-left: 8px;">{node.label}</span>
            </span>
          );
        }
      }
    },
    // 详情
    dataSetDetail(row) {
      console.log(row);
      setStore({
        name: "od_detail_id",
        content: row.id,
        type: "session"
      });
      setStore({
        name: "od_dataBase_id",
        content: row.apiServerDataBaseId,
        type: "session"
      });
      this.changeComponentName("odDetail");
    },
    // 验证
    validateTwo(prop, msgStatus, validateMessage) {
      // console.log(prop, msgStatus, validateMessage)
      if (!msgStatus && !this.countNum) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 新增
    addItem(row) {
      this.$emit("toFAQInfo", row);
      // console.log(this.apiServerDataBaseId, '222')
      sessionStorage.setItem('apiServerDataBaseId', this.apiServerDataBaseId)
      // this.changeComponentName('FaqConfig')
    },
    // 新增数据集
    addData(node, item) {
      this.$emit("toTypeInfo", null);
    },
    // 高级检索
    toHignSearch(res) {
      // console.log(res)
      this.hignSearchRes = res;
      this.pageNum = 1;
      this.hignModal = false;
      this.getFAQList();
    },
    // 编辑分类
    editDataBase(item) {
      this.$emit("toTypeInfo", item);
    },
    getRowKey(row) {
      return row.questionId;
    },
    //表格多选框选中
    handleSelectChange(selection) {
      console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].questionId);
      }
      this.checkID = this.checkClassList.join(",");
    },
    // 鼠标移入节点
    treeNodeHover(node, data) {
      // console.log(node)
      this.treeData.forEach(element => {
        if (element.children) {
          element.children.forEach(elements => {
            if (elements.id === data.id) {
              elements.show = true;
            } else if (this.selectData && this.selectData.id !== elements.id) {
              elements.show = false;
            }
          });
        }
      });
    },
    // 鼠标移出
    treeNodeLeave(node, data) {
      // console.log(data)
      this.treeData.forEach(element => {
        if (element.children) {
          element.children.forEach(elements => {
            if (this.selectData && this.selectData.id !== elements.id) {
              elements.show = false;
            }
          });
        }
      });
    },
    // 点击节点
    handleNodeClick(data, node) {
      console.log(data);
      console.log(node);
      if (node.level === 1) {
        // 点击所有分类则默认搜索全部数据集
        this.apiServerDataBaseId = "";
        this.getFAQList();
      }
      // console.log(this.treeData);
      this.selectData = data;
      this.treeData.forEach(element => {
        if (element.children) {
          element.children.forEach(elements => {
            if (elements.questionType === data.questionType) {
              // console.log(elements)
              elements.show = true;
              this.apiServerDataBaseId = elements.questionType;
              this.getFAQList();
            } else {
              elements.show = false;
            }
          });
        }
      });
      console.log(this.apiServerDataBaseId);
      setStore({
        name: "faq_baseTree_id",
        content: this.apiServerDataBaseId,
        type: "session"
      });
    },
    // 确认弹窗
    agreeNotice() {
      if (this.deleteType === 1) {
        this.faqTypeRemove();
      } else if (this.deleteType === 2) {
        this.faqRemove(this.delectID);
      } else if (this.deleteType === 3) {
        console.log(this.checkID);
        this.faqRemove(this.checkID);
      } else if (this.deleteType === 4) {
        this.noticeModal = false;
      }
    },
    // 关闭弹窗
    closeNotice() {
      // console.log(111)
      this.delectID = "";
      this.noticeModal = false;
    },
    // 删除分类
    deleteDataBase(data) {
      // console.log(data)
      this.apiServerDataBaseId = data.questionType;
      this.deleteType = 1;
      this.noticeSpec = ""; // 标红提示
      this.noticeType = 1; // 提示类型
      this.agreeContent = "确认"; // 提示弹窗确认按钮内容
      this.noticeTitle = "确认操作"; // 提示
      this.noitceContent = "是否确认删除？"; // 提示信息
      this.noticeModal = true;
    },
    // 删除分类
    async faqTypeRemove() {
      console.log("0000000000");
      const faqTypeRemove = await this.$store.dispatch("removeFAQType", {
        questionType: this.apiServerDataBaseId
      });
      console.log(faqTypeRemove);
      if (faqTypeRemove.data.status === 1000) {
        this.$message.success("操作成功");
        this.noticeModal = false;
        this.getFAQTypeList();
      } else if (faqTypeRemove.data.status === 1002) {
        this.noticeModal = false;
        this.deleteType = 4;
        this.noticeSpec = ""; // 标红提示
        this.noticeType = 2; // 提示类型
        this.agreeContent = "我知道了"; // 提示弹窗确认按钮内容
        this.noticeTitle = "提示"; // 提示
        this.noitceContent = faqTypeRemove.data.msg; // 提示信息
        this.noticeModal = true;
      } else {
        this.$message.error(faqTypeRemove.data.msg);
      }
    },
    // 删除
    deleteItem(row) {
      // console.log(row)
      this.noticeSpec = ""; // 标红提示
      (this.noticeType = 1), // 提示类型
        (this.agreeContent = "确认"); // 提示弹窗确认按钮内容
      this.noticeTitle = "确认操作"; // 提示
      this.noitceContent = "是否确认删除？"; // 提示信息
      if (!row) {
        if (this.checkClassList.length == 0) {
          this.$message.error("请勾选数据");
        } else {
          this.deleteType = 3;
          this.noticeModal = true;
        }
      } else {
        this.delectID = row.questionId;
        this.deleteType = 2;
        this.noticeModal = true;
      }
    },
    // 删除数据集
    async faqRemove(ids) {
      const {
        data: { msg, status }
      } = await this.removeFAQ({
        ids: ids
      });
      if (status === 1000) {
        this.noticeModal = false;
        this.$message.success("删除成功");
        this.$refs.faqTableData.clearSelection();
        this.checkClassList = [];
        this.delectID = "";
        this.getFAQList();
        return;
      }
      this.$message.error(msg);
    },
    // 刷新树节点
    refreshTree() {
      console.log("刷新树");
      this.getFAQTypeList();
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true;
    },
    //条数变化
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageNum = 1;
      this.pageSize = val;
      this.getFAQList();
    },
    //页码变化
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getFAQList();
    },
    search() {
      this.hignSearchRes = "";
      this.pageNum = 1;
      this.getFAQList();
    },
    getTableList(value) {
      this.tableDataShow = value;
    },
    getDataOrder(value) {
      this.orderConfig = value;
      this.getFAQList();
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session"
      });
    },
    //表单重置
    reset() {
      this.$refs["searchForm"].resetFields();
      this.$refs.faqTableData.clearSelection();
      this.checkClassList = [];
      this.delectID = "";
      this.searchForm = {
        questionName: "",
        faqType: "",
        faq: "",
        display: ""
      }
      this.search();
    },
    // 查询分类列表
    async getFAQTypeList() {
      const getFAQTypeList = await this.$store.dispatch("questionTypeList");
      setStore({
        name: "saveFAQTypeList",
        content: getFAQTypeList.data.result,
        type: "session"
      });
      if (getFAQTypeList.data.status === 1000) {
        this.treeData[0].children = getFAQTypeList.data.result;
        this.apiServerDataBaseId = getStore({
          name: "faq_baseTree_id",
          type: "session"
        });
        if (this.apiServerDataBaseId) {
          this.treeData[0].children.forEach(elements => {
            if (elements.questionType === this.apiServerDataBaseId) {
              this.selectData = elements;
            }
          });
        } else {
          this.selectData = this.treeData[0];
        }
        this.selectData.show = true;
        this.$nextTick(() => {
          this.$refs.treeList.setCurrentKey(this.selectData.questionType);
        });
        this.getFAQList();
      } else {
        this.$message.error(getFAQTypeList.data.msg);
      }
    },
    //获取列表
    async getFAQList() {
      let dataSortStr = this.orderConfig;
      if (Array.isArray(this.orderConfig)) {
        // console.log("看一看orderConfig的type",Array.isArray(this.orderConfig));
        dataSortStr = this.orderConfig.join(",");
      }
      this.loading = true
      const getFAQList = await this.$store.dispatch("aiquestionList", [
        {
          current: this.pageNum,
          size: this.pageSize
        },
        {
          questionName: this.searchForm.questionName,
          questionType: this.apiServerDataBaseId,
          answerType: this.searchForm.faqType,
          answer: this.searchForm.faq,
          isShow: this.searchForm.display,
          advancedSearch: this.hignSearchRes,
          dataSortStr: dataSortStr
        }
      ]);
      this.loading = false
      console.log(getFAQList);
      if (getFAQList.data.status === 1000) {
        if (getFAQList.data.result.records.length !== 0) {
          this.tableData = getFAQList.data.result.records;
          this.total = getFAQList.data.result.total;
        } else {
          if (this.pageNum !== 1) {
            this.pageNum -= 1;
            this.getFAQList();
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      } else {
        this.tableData = [];
        this.total = 0;
      }
    }
  }
};
</script>

<style lang='scss'>
.faq-library-basicpage {
  .el-table__body-wrapper {
      height: calc(100vh - 193px)!important;
  }
  .node-delete,
  .node-edit {
    opacity: 0;
  }
  .el-tree-node__content:hover .node-delete {
    opacity: 1;
  }
  .el-tree-node__content:hover .node-edit {
    opacity: 1;
  }
  .el-tree-node .is-current > .el-tree-node__content {
    .node-delete {
      opacity: 1;
    }
    .node-edit {
      opacity: 1;
    }
  }
  .tableThree-height-shu {
    display: inline-block;
    padding: 0 4px;
    position: relative;
    .shu-item {
      position: absolute;
      width: 1px;
      height: 12px;
      background-color: #d4d4d7;
      display: inline-block;
      top: -10px;
    }
  }
  .left-tree {
    height: calc(100vh - 158px) !important;
  }
	.add-node {
		// position: absolute;
		margin-left: 8px;
		font-size: 12px;
		cursor: pointer;
		z-index: 999;
		top: 0px;
		right: 28px;
		font-size: 12px;
	}
  .tableListPage {
    .el-table__body-wrapper {
      height: calc(100vh - 193px) !important;
    }
		.delete-node,
		.edit-node,
		.child-add-node {
			// position: absolute;
			margin-left: 8px;
			font-size: 12px;
			cursor: pointer;
			z-index: 999;
			top: 0;
			display: inline-block;
			opacity: 0;
		}
		.delete-node {
			right: 8px;
		}
		.edit-node {
			right: 28px;
		}
		.child-add-node {
			right: 48px;
		}
		.el-tree-node__content:hover .delete-node {
			opacity: 1;
		}
		.el-tree-node__content:hover .edit-node {
			opacity: 1;
		}
		.el-tree-node__content:hover .child-add-node {
			opacity: 1;
		}
		.el-tree-node .is-current > .el-tree-node__content {
			.delete-node {
				opacity: 1;
			}
			.child-add-node {
				opacity: 1;
			}
			.edit-node {
				opacity: 1;
			}
		}
  }
  .custom-tree_tab {
    font-size: 12px;
    width: 100% !important;
    text-align: left !important;
    padding: 0 8px;
    cursor: default !important;
  }
}
.dic-modal {
  .el-dialog__body {
    height: auto;
  }
}
</style>
